(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["live-viewers"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('live-product-viewers')) return;

    function hash(str) {
      var h = 0;
      for (var i = 0; i < str.length; i++) {
        h = (h << 5) - h + str.charCodeAt(i);
        h |= 0;
      }
      return Math.abs(h);
    }

    function clamp(v, a, b) {
      return Math.max(a, Math.min(b, v));
    }

    class LiveProductViewers extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.countEl = this.querySelector('[data-viewers-count]');
        if (!this.countEl) return;

        var min = parseInt(this.dataset.min, 10) || 1;
        var max = parseInt(this.dataset.max, 10) || min;
        if (max < min) max = min;
        this.min = min;
        this.max = max;
        this.interval = (parseInt(this.dataset.interval, 10) || 0) * 1000;

        var pid = this.dataset.productId || 'product';
        this.storageKey = 'liveViewers:' + pid;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Base: valor guardado en la sesión > valor renderizado por el servidor > cálculo determinístico.
        var current = parseInt(this.countEl.textContent, 10);
        try {
          var saved = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
          if (saved && typeof saved.count === 'number') current = saved.count;
        } catch (e) {}

        if (!current || current < min || current > max) {
          var seed = hash(pid + ':' + new Date().getHours());
          current = min + (seed % (max - min + 1));
        }
        current = clamp(current, min, max);

        this.render(current);
        this.persist(current);
        this.sendAnalytics(current);

        // Fluctuación ligera para simular actividad "en vivo" (se desactiva con reduce-motion).
        if (this.interval > 0 && !reduce) {
          var self = this;
          this._timer = setInterval(function () {
            var delta = Math.floor(Math.random() * 5) - 2; // -2 .. +2
            self._value = clamp(self._value + delta, self.min, self.max);
            self.render(self._value);
            self.persist(self._value);
          }, this.interval);
        }
      }

      disconnectedCallback() {
        if (this._timer) clearInterval(this._timer);
      }

      render(value) {
        this._value = value;
        if (this.countEl) this.countEl.textContent = value;
      }

      persist(value) {
        try {
          sessionStorage.setItem(this.storageKey, JSON.stringify({ count: value, t: Date.now() }));
        } catch (e) {}
      }

      sendAnalytics(value) {
        if (this.dataset.analytics !== 'true') return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'social_proof_impression',
          social_proof_type: 'live_viewers',
          product_id: this.dataset.productId || null,
          viewers_count: value
        });
      }
    }

    customElements.define('live-product-viewers', LiveProductViewers);
  })();
  } catch(e) { console.error(e); }
})();

})();
